import DaybookSetupView from "./Index.vue";
import NewTaskListView from "./NewTaskListView.vue";
import EditTaskListView from "./EditTaskListView.vue";

export { DaybookSetupView, NewTaskListView, EditTaskListView };
export default DaybookSetupView;
